<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <h4>聯絡資訊(公司提供)是否協助我找到客戶?</h4>
          <div class="radio radio-inline">
            <input
            type="radio"
            name="iaa_useful"
            id="iaa-useful-1"
            v-model="iaaUseful"
            value="1">
            <label for="iaa-useful-1">是</label>
          </div>
          <div class="radio radio-inline">
            <input
            type="radio"
            name="iaa_useful"
            id="iaa-useful-2"
            v-model="iaaUseful"
            value="0">
            <label for="iaa-useful-2">否</label>
          </div>

          <div class="action text-right">
            <a @click="cancel()" class="btn btn-default">
              取消
            </a>
            <a @click="send()" class="btn btn-primary">
              確定
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addIAA_API } from '../../service';
import { updateIAA_API } from '../../service';

export default {
  name: 'IaaReportModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    hasData:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      iaaUseful: 0
    }
  },
  methods: {
    send () {
      let isSuccess = false
      if(this.hasData) {
        if(this.iaaUseful == 1) { //選[是]
          //updateIAA_API
          var check_item = {
            tel: 0,
            mobile1: 0 ,
            mobile2: 0 ,
            addr: 0,
            email: 0
          } 

          updateIAA_API(this.$store.state.userInfo.id, this.$store.state.custInfo.ID, this.iaaUseful, check_item, 'update').then(result =>{
            if(result.header.status && result.header.status == "200") {
              isSuccess = true
            }
            this.$emit('close', isSuccess)
          })
          
        } else { //選[否]
          this.$emit('submit', this.iaaUseful)
        }
      } else { //查無資料
        if(this.iaaUseful == 1) { //選[是]
          //addIAA
          var check_item = {
            tel: 0,
            mobile1: 0 ,
            mobile2: 0 ,
            addr: 0,
            email: 0
          } 
          
          addIAA_API(this.$store.state.userInfo.id, this.$store.state.custInfo.ID, this.iaaUseful, check_item, 'add').then(result =>{
            if(result.header.status && result.header.status == "200") {
              isSuccess = true
            }
            this.$emit('close', isSuccess)
          })
          
        } else { //選[否]
          this.$emit('submit', this.iaaUseful)
        }
      }
    }, 
    cancel () {
      this.$emit('close', false) //傳回false代表按下{取消}不做任何更新
    }
  } 
}
</script>
